<script>
import {
  collectOrphanCustomAssets,
  buildOrphanCustomAssetMessage,
} from '@modules/consolidator/utils/orphan-custom-assets/orphan-custom-assets'
import ValidationErrors from '@modules/consolidator/components/validation-errors.vue'

export default {
  name: 'OrphanAssetsWarnings',
  components: { ValidationErrors },
  props: {
    walletAnalysis: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    messages() {
      return this.orphanAssets.map((asset) =>
        buildOrphanCustomAssetMessage(asset)
      )
    },
    orphanAssets() {
      const linked =
        (this.$store &&
          this.$store.getters['consolidator/recentlyLinkedAssetIds']) ||
        []
      return collectOrphanCustomAssets(this.walletAnalysis).filter(
        (asset) => !linked.includes(asset.id)
      )
    },
  },
  methods: {
    handleLink(index) {
      const asset = this.orphanAssets[index]
      if (!asset) return
      this.$emit('link-asset', asset)
    },
  },
}
</script>

<template>
  <ValidationErrors
    v-if="messages.length"
    class="orphan-assets-warnings"
    :errors="messages"
  >
    <template v-slot:action="{ index }">
      <BaseButton
        small
        dark
        outline
        min-width="80px"
        class="mx-10"
        @click="handleLink(index)"
      >
        Vincular à base
      </BaseButton>
    </template>
  </ValidationErrors>
</template>
